export default "__VITE_ASSET__DspuRrsc__"